import { useEffect, useContext } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export function useBlocker(handleBlockedNavigation, shouldBlock = false) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!shouldBlock) return;

    const unblock = navigator.block((transition) => {
      const autoUnblockingTransition = {
        ...transition,
        retry() {
          unblock();
          transition.retry();
        },
      };
      handleBlockedNavigation(autoUnblockingTransition);
    });

    return unblock;
  }, [navigator, handleBlockedNavigation, shouldBlock]);
}
